import { UnitAttributeVisualizerComponent } from
  '../../components/shared/unit-attribute-visualizer/unit-attribute-visualizer.component';

export class UnitEntityAttribute {
  constructor(public mapEntityId: string, public entity: any) {}

  getVisualizer() {
    return {
      component: UnitAttributeVisualizerComponent,
      inputs: { mapEntityId: this.mapEntityId, entity: this.entity }
    };
  }
} 
